module.exports = __webpack_public_path__ + "img/调查问卷.4966a60b.svg";